import React, {Component} from 'react';
import {Dropdown, Button, Modal, Form} from 'semantic-ui-react';

import Alert from "../../components/extras/Alert";
import DataService from "../../functions/DataService";


class SaleStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            delivery_state: props.delivery_state,
            observations: '',
            id: props.id,
            loading: false,
            options: props.options,
            modal_observation: false,
            tmp_delivery_state: null
        };

        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCloseModalObservation = this.handleCloseModalObservation.bind(this);
        this.handleObservationsChange = this.handleObservationsChange.bind(this);
        this.handleSubmitChangeState = this.handleSubmitChangeState.bind(this);
    }

    handleStateChange = (delivery_state) => {
        if(delivery_state !== this.state.delivery_state){
            this.setState({observations: '', modal_observation: true, tmp_delivery_state: delivery_state})
        }
    };

    handleCloseModalObservation = () => {
        this.setState({modal_observation: false})
    }

    updateState(){
        this.setState({loading:true});
        let data = {id:this.state.id, delivery_state:this.state.tmp_delivery_state, observations: this.state.observations}
        DataService.doAction(data,`sales/status/${this.state.id}`, 'PATCH', (res) =>{
            if(res.update){
                this.setState({delivery_state: this.state.tmp_delivery_state});
                this.refs.alert.open({message:'Estado actualizado!', type:'success'});
            }else {
                this.refs.alert.open({message:'Tenemos un problema!', type:'error'});
            }
        });
        this.setState({loading:false, modal_observation:false})
    }

    handleObservationsChange = (observations) => {
        this.setState({observations})
    };

    handleSubmitChangeState = () => {
        if(this.state.observations != ''){
            this.updateState();
        }
    }

    render() {
        return (
            <div>
                <Button.Group fluid color={this.state.options.find((option) => option.key === this.state.delivery_state).color}>
                <Dropdown
                    options={this.state.options}
                    floating
                    fluid
                    button
                    labeled
                    icon={this.state.options.find((option) => option.key===this.state.delivery_state).icon}
                    className='icon'
                    value={this.state.delivery_state}
                    onChange={(e, { value }) => this.handleStateChange(value)}
                />
            </Button.Group>
            <Alert ref='alert' />
            <Modal size='tiny' dimmer='inverted' open={this.state.modal_observation} onClose={this.handleCloseModalObservation}>
                <Modal.Header>
                    Actualizar Estado
                </Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <Form onSubmit={this.handleSubmitChangeState}>
                            <Form.TextArea label='Observaciones' placeholder='Observaciones' value={this.state.observations} onChange={(e, {value}) => this.handleObservationsChange(value)}/>
                        </Form>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.handleCloseModalObservation} icon='x' labelPosition='left' content="Cancelar"/>
                    <Button primary loading={this.state.loading} disabled={this.state.loading} icon='check' labelPosition='left' content='Actualizar' onClick={this.handleSubmitChangeState}/>
                </Modal.Actions>
            </Modal>
        </div>
        );
    }
}

export default SaleStatus;



// WEBPACK FOOTER //
// ./src/components/sale/SaleStatus.js